import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

import {setCookie, getCookie} from './helpers/cookies';
import {getLog, postLog} from './helpers/log';

const TicketSign = (props) => {
    const {config} = props;
    const [acfData, setAcfData] = useState(null);
    const [authenticationToken, setAuthenticationToken] = useState(null);
    const [todaysTicketData, setTodaysTicketData] = useState(null);

    // Retrieve ACF content
    useEffect(() => {
        const fetchACF = async () => {
            await fetch(`https://${config.domain}/wp-json/wp/v2/pages/${config.pageId}?acf_format=standard`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(response);
                    }

                    return response.json();
                })
                .then(data => {
                    setAcfData(data);
                    console.log(data);
                })
                .catch(error => {
                    console.log(error);
                })
        };

        fetchACF();
    }, []);
    
    // Authenticate to access SATAPI and save token for 1 year
    useEffect(() => {
        if (!getCookie('SATAPI_token')) {
            const authenticateApp = async () => {
                try {
                    const response = await fetch(`https://${config.apiUrl}/oauth/token`, {
                        method: 'POST',
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            "grant_type": "client_credentials",
                            "client_id": (config.domain == 'www.seattleaquarium.org' || config.domain == 'seattleaquarium.org' || config.domain == 'seaaquariumweb.wpenginepowered.com') ? "3" : "1", // prod / dev
                            "client_secret": (config.domain == 'www.seattleaquarium.org' || config.domain == 'seattleaquarium.org' || config.domain == 'seaaquariumweb.wpenginepowered.com') ? "apFsFzcyBHGdUIUYPaAr8vHQCUa2GeUwnvQV0mVH" : "hOBRisrrRv9KWJrT2pD52e0JdgaXdl5tqDafnJSd", // prod / dev
                            "scope": "*"
                        })
                    });
                    if (!response.ok) {
                        throw new Error("Authentication error");
                    }
                    const token = await response.json();
                    setAuthenticationToken(token.access_token);
                    setCookie('SATAPI_token', token.access_token, 7); // disable cookie
                } catch (error) {
                    console.error(error);
                }
            };

            authenticateApp();
        } else {
            setAuthenticationToken(getCookie('SATAPI_token'));
        }
    }, []);
        
    // fetch today's ticket data
    useEffect(() => {
        const fetchData = async () => {
            let fetchUrl = `https://${config.apiUrl}/api/prices/display`;

            try {
                const response = await fetch(fetchUrl, {
                    method: 'GET',
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": authenticationToken
                    }
                });
                if (!response.ok) {
                    postLog(config, authenticationToken, response.url, String(response.status));
                    throw new Error(response.url + ' ' + response.statusText);
                }
                const data = await response.json();
                setTodaysTicketData(data.data);
                console.log(data.data);
            } catch (error) {
                console.error(error);
            }
        };

        if (authenticationToken != null) {
            fetchData();
        }
    }, [authenticationToken]);

    return (
        <>
            <style>
                {`#full-width {
                    --font-color: ${acfData && (acfData.acf.font_color != false) ? acfData.acf.font_color : 'inherit'};
                    --font-color-2: ${acfData && (acfData.acf.font_color_2 != false) ? acfData.acf.font_color_2 : 'inherit'};
                }`}

                {`#full-width {
                    background-color: ${acfData && (acfData.acf.background_color != false) ? acfData.acf.background_color + '!important': 'unset'};
                    background-image: url(${acfData && (acfData.acf.background_image != false) ? acfData.acf.background_image.url : 'unset'}) !important;
                }`}
                {acfData && (acfData.acf.background_color != false) && (acfData.acf.background_color_2 != false) && <>
                    {`#full-width {
                        background: linear-gradient(-45deg, ${acfData.acf.background_color}, ${acfData.acf.background_color_2}) !important;
                    }`}
                </>}
            </style>

            {!todaysTicketData && <i className="fa fa-spinner fa-pulse"></i>}
            {todaysTicketData && <div className="ticket-sign">
                <h1 className="ticket-sign__title" style={{color: 'var(--font-color)'}}>Tickets</h1>
                <table className="ticket-sign__table">
                    <thead>
                        <tr>
                            <th></th>
                            <th style={{color: 'var(--font-color-2)'}}>Adult <span>(13 &amp; over)</span></th>
                            <th style={{color: 'var(--font-color-2)'}}>Youth <span>(4-12)</span></th>
                            <th style={{color: 'var(--font-color-2)'}}>Child <span>(0-3)</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* ACME sourced rows */}
                        {acfData && acfData.acf.prices_override === false && <>
                            <tr>
                                <th style={{color: 'var(--font-color)'}}>General admission</th>
                                <td>{(todaysTicketData.Adult == 'free') ? 'Free' : '$' + todaysTicketData.Adult}</td>
                                <td>{(todaysTicketData.Youth == 'free') ? 'Free' : '$' + todaysTicketData.Youth}</td>
                                <td>{(todaysTicketData.Child == 'free') ? 'Free' : '$' + todaysTicketData.Child}</td>
                            </tr>
                            <tr>
                                <th style={{color: 'var(--font-color)'}}>WA state admission</th>
                                <td>{(todaysTicketData.WAAdult == 'free') ? 'Free' : '$' + todaysTicketData.WAAdult}</td>
                                <td>{(todaysTicketData.WAYouth == 'free') ? 'Free' : '$' + todaysTicketData.WAYouth}</td>
                                <td>{(todaysTicketData.WAChild == 'free') ? 'Free' : '$' + todaysTicketData.WAChild}</td>
                            </tr>
                            <tr>
                                <th style={{color: 'var(--font-color)'}}>Members</th>
                                <td>Free</td>
                                <td>Free</td>
                                <td>Free</td>
                            </tr>
                        </>}

                        {/* ACF sourced rows */}
                        {acfData && acfData.acf.prices_override.length > 0 && <>
                            {acfData.acf.prices_override.map(row => {
                                return <tr>
                                    <th>{row.type}</th>
                                    <td>{row.adult_price}</td>
                                    <td>{row.youth_price}</td>
                                    <td>{row.child_price}</td>
                                </tr>
                            })}
                        </>}
                    </tbody>
                </table>
                <table className="ticket-sign__table">
                    <thead>
                        <tr>
                            <th></th>
                            <th style={{color: 'var(--font-color-2)'}}>Adult <span>(13 &amp; over)</span></th>
                            <th style={{color: 'var(--font-color-2)'}}>Youth <span>(5-12)</span></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <th style={{color: 'var(--font-color)'}}>CityPASS<div>Admission to top five Seattle attractions</div></th>
                        <td>{acfData && acfData.acf.citypass_prices.adult_price}</td>
                        <td>{acfData && acfData.acf.citypass_prices.youth_price}</td>
                        <td></td>
                    </tbody>
                </table>
                {acfData && acfData.acf.footer_text && <div className="ticket-sign__footer" dangerouslySetInnerHTML={{ __html:acfData.acf.footer_text }} />}
            </div>}
        </>
    );
}

// ReactDOM.render(
//     <TicketSign />,
//     document.getElementById('ticket-sign')
// );

var App = function(config) {
    ReactDOM.render(
        <TicketSign config={config} />,
        document.getElementById('ticket-sign')
    );
}

window.App = App;